module.exports = __webpack_public_path__ + "img/piscina.0e8b3535.svg";